import { useLive, useServices } from "../context";

export function Notices() {
  const { controller } = useServices();
  const notices = useLive((s) => s.notices);
  if (notices.length === 0) return null;
  return (
    <div className="notices" role="region" aria-label="Notifications">
      {notices.map((n) => (
        <div key={n.id} className={`notice ${n.level}`} role={n.level === "error" ? "alert" : "status"}>
          <span>{n.text}</span>
          <button type="button" aria-label="Dismiss notification" onClick={() => controller.dismissNotice(n.id)}>×</button>
        </div>
      ))}
    </div>
  );
}
